module.exports = __webpack_public_path__ + "img/yahav-large.ac420862.jpg";